import { memo } from "react";
function FileUploadIcon({ color = "#05A792",width, height }) {
  return (
    <svg
      width={width ??"15"}
      height={height ??"15"}
      viewBox="0 0 32 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1 33.9C16.5333 33.9 16.8917 33.7583 17.175 33.475C17.4583 33.1917 17.6 32.8333 17.6 32.4V23.85L20.7 26.95C20.9667 27.2167 21.3 27.35 21.7 27.35C22.1 27.35 22.45 27.2 22.75 26.9C23.05 26.6 23.2 26.2417 23.2 25.825C23.2 25.4083 23.05 25.0667 22.75 24.8L17.05 19.3C16.8833 19.1333 16.7167 19.0167 16.55 18.95C16.3833 18.8833 16.2 18.85 16 18.85C15.8 18.85 15.6167 18.8833 15.45 18.95C15.2833 19.0167 15.1167 19.1333 14.95 19.3L9.3 24.95C9.03333 25.2167 8.9 25.55 8.9 25.95C8.9 26.35 9.05 26.7 9.35 27C9.65 27.3 10 27.45 10.4 27.45C10.8 27.45 11.15 27.3 11.45 27L14.6 23.85V32.4C14.6 32.8333 14.7417 33.1917 15.025 33.475C15.3083 33.7583 15.6667 33.9 16.1 33.9ZM3 40C2.2 40 1.5 39.7 0.9 39.1C0.3 38.5 0 37.8 0 37V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H19.8C20.2 0 20.5833 0.0749999 20.95 0.225C21.3167 0.375 21.65 0.6 21.95 0.9L31.1 10.05C31.4 10.35 31.625 10.6833 31.775 11.05C31.925 11.4167 32 11.8 32 12.2V37C32 37.8 31.7 38.5 31.1 39.1C30.5 39.7 29.8 40 29 40H3ZM19.55 3H3V37H29V12.3H21.05C20.6167 12.3 20.2583 12.1583 19.975 11.875C19.6917 11.5917 19.55 11.2333 19.55 10.8V3ZM3 3V10.8C3 11.2333 3 11.5917 3 11.875C3 12.1583 3 12.3 3 12.3V3V10.8C3 11.2333 3 11.5917 3 11.875C3 12.1583 3 12.3 3 12.3V37V3Z"
        fill={color}
      />
    </svg>
  );
}

export default memo(FileUploadIcon);
